function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M29 0a3 3 0 013 3v26a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h26z",
  fill: "url(#paint0_linear_787_2738)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6 4.15L6 9h16.06c.13 0 .25-.05.34-.15l3.8-4a.51.51 0 00.1-.53.49.49 0 00-.44-.32H10.94a.46.46 0 00-.34.15zM10.6 27.85L6 23h16.06c.13 0 .25.05.34.15l3.8 4c.13.14.17.35.1.53a.49.49 0 01-.44.32H10.94a.46.46 0 01-.33-.15",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".74",
  d: "M11 9H6v14h5V9",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_787_2738",
  x1: "0",
  y1: "0",
  x2: "0",
  y2: "32",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97C93D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#3D9544"
}))));